import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { removeHashFromPath } from '../../../utils/removeHashFromPath'

export const useRedirectHashUrls = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    // redirect old HashRouter views URLs to new Router views URLs

    // URLs with only query params after hash
    // from /org-name/debtorbalance#/?searchQuery=test
    // to   /org-name/debtorbalance?searchQuery=test

    // URLs with a path after hash
    // from /org-name/settings#/organization
    // to   /org-name/settings/organization

    const updatedHashPart = removeHashFromPath(location.hash)

    if (updatedHashPart !== location.hash) {
      navigate(`${location.pathname}${updatedHashPart}`, { replace: true })
    }
    // Only meant to fix up the URL once, on mount - not on every subsequent navigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
